import { graphic } from 'echarts'

// 格式化数字
const formatNumber = (num) => {
  return Number(num || 0).toFixed(0)
}

export default (categories, data) => {
  return {
    legend: {
      show: true,
      top: 0,
      right: 12,
      icon: 'circle',
      itemWidth: 8,
      itemHeight: 8,
      textStyle: {
        fontSize: 12,
        fontFamily: 'HarmonyOS Sans SC',
        color: 'rgba(46, 46, 46, 0.70)'
      },
      data: ['告警总数']
    },
    grid: {
      top: 30,
      bottom: 40,
      left: 60,
      right: 20
    },
    xAxis: {
      type: 'category',
      data: categories,
      axisLabel: {
        fontSize: 12,
        fontFamily: 'HarmonyOS Sans SC',
        fontWeight: 300,
        color: 'rgba(46, 46, 46, 0.70)'
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      min: 0,
      name: '告警数',
      nameTextStyle: {
        fontSize: 12,
        fontFamily: 'HarmonyOS Sans SC',
        fontWeight: 300,
        color: 'rgba(46, 46, 46, 0.70)'
      },
      axisLabel: {
        fontSize: 12,
        fontFamily: 'HarmonyOS Sans SC',
        fontWeight: 300,
        color: 'rgba(46, 46, 46, 0.70)'
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(106, 114, 124, 0.1)',
          type: 'dashed'
        }
      }
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0.90)',
      borderColor: 'transparent',
      borderRadius: 16,
      extraCssText: 'backdrop-filter: blur(4px); box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);',
      textStyle: {
        color: '#2E2E2E',
        fontFamily: "HarmonyOS Sans SC",
        fontSize: 14
      },
      axisPointer: {
        type: 'line'
      },
      formatter: (params) => {
        if (params && params.length > 0) {
          const param = params[0]
          return `<div style="color: rgba(46, 46, 46, 0.70); font-family: 'HarmonyOS Sans SC'; font-size: 12px; margin-bottom: 4px;">${param.name}</div>
                     <div style="display: flex; align-items: center; gap: 4px; color: #2E2E2E; font-family: 'HarmonyOS Sans SC'; font-size: 14px;">
                      <span style="display:inline-block;margin-right:4px;border-radius:10px;width:6px;height:6px;background-color:#3A68FF;"></span>
                      总告警: ${formatNumber(param.value)} 次</div>`
        }
        return ''
      }
    },
    series: [{
      name: '告警总数',
      type: 'line',
      data: data,
      smooth: true,
      symbol: 'circle',
      symbolSize: 6,
      lineStyle: {
        color: '#3A68FF',
        width: 2
      },
      itemStyle: {
        color: '#3A68FF'
      },
      areaStyle: {
        color: graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: 'rgba(58, 104, 255, 0.3)'
        },
        {
          offset: 1,
          color: 'rgba(58, 104, 255, 0.05)'
        }
        ])
      }
    }]
  }
}

